import { render } from "./favourite-five.vue?vue&type=template&id=6fa8c05c"
import script from "./favourite-five.vue?vue&type=script&lang=js"
export * from "./favourite-five.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__